import React, { useEffect, useState } from "react";
import { selectCurrent } from './../redux/theme/selectors'
import { useAppDispatch, useAppSelector } from "../hooks/hooks";
import { theme } from "../redux/theme/actions";
export default function AddEditTheme() {
	const dispatch = useAppDispatch();
	const [steps, setSteps] = useState({});
	const handleClose = () => {
		dispatch(theme.set({ addTheme: 'close' }))
	}

	const { isEditTheme, addTheme } = useAppSelector(selectCurrent)
	const handleSteps = (e: any, key: any) => {
		setSteps({ ...steps, [key]: e.target.value })
	}

	const handleReset = () => {
		setSteps({ firstName: '', lastName: '', mobile: '', email: '', Block: '', Type: '', UnitDetails: '', AssignCRM: '', AssignSiteEngineer: '', Status: '', Stage: '' })
	}

	const handleSave = () => {

	}

	return (
		<>
			{addTheme == 'open' ? (
				<>
					<div className="absolute fixed w-full mt-10 inset-0 z-50 flex flex-warp justify-center align-middle">
						<div className="w-[600px] my-2 mx-auto max-w-sm">
							<div className="rounded-lg shadow-lg flex flex-col w-[600px] bg-white">
								<div className="flex items-center justify-between mx-2 mr-4 py-2 my-2 w-[600px]">
									<div className="flex flex-col items-start justify-start mx-1 mt-3 mb-4">
										<span className="text-xl">UI Theme Designer </span>
										<span className="text-xs pr-15">Visual editor is for quick prototyping, for advanced editing such as implementing your style guide </span>
									</div>
									<div className="cursor-pointer mx-10">
										<svg onClick={() => handleClose()} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" className="lucide lucide-x-circle"><circle cx="12" cy="12" r="10" /><path d="m15 9-6 6" /><path d="m9 9 6 6" /></svg>
									</div>
								</div>
								<div className="flex flex-row space-x-2 px-4 w-full my-2">
									<div className="w-1/2">
										<label
											className="block  text-xs font-bold"
											htmlFor="grid-password">
											Theme Name
										</label>
										<div className="border-0  bg-[#F3F4F6FF] text-xs " >
											<input
												type="text"
												name={"themeName"}
												className="w-full px-3 py-1 bg-[#F3F4F6FF] text-xs  "
												onChange={(e) => handleSteps(e, 'themeName')}
												value={'..'}
											/>
										</div>
									</div>
									<div className="w-1/2">
										<label
											className="block text-xs font-bold"
											htmlFor="grid-password">
											Theme Owner
										</label >
										<div className="border-0  bg-[#F3F4F6FF] text-xs " >
											<input
												type="text"
												name={"themeOwnwer"}
												placeholder=""
												className="w-full px-3 py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'themeOwnwer')}
												value={'...'}
											/>
										</div>
									</div>
								</div>
								<div className="my-2 border-b border-black border-opacity-20"></div>
								<div className="mx-5">Palette </div>
								<div className="my-2 border-b border-black border-opacity-20"></div>
								<div className="flex flex-col space-y-2 px-4 w-full my-2">
									<div className="w-1/2">
										<label
											className="block  text-xs font-bold"
											htmlFor="grid-password">
											Primary
										</label>
										<div className="border-0 w-[80px] bg-[#F3F4F6FF] text-xs " >
											<input
												type="text"
												name={"email"}
												className="w-[20px] px-3 py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'email')}
												value={'email'}
											/>
										</div>
									</div>
									<div className="w-1/2">
										<label
											className="block text-xs font-bold"
											htmlFor="grid-password">
											Secondary
										</label >
										<div className="w-[80px] border-0  bg-[#F3F4F6FF] text-xs " >
											<input
												type="text"
												name={"mobile"}
												placeholder=""
												className="w-[20px] px-3 py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'mobile')}
												value={'mobile'}
											/>
										</div>
									</div>
								</div>

								<div className="my-2 border-b border-black border-opacity-20"></div>
								{/* <div className="flex flex-row space-x-2 px-4 w-full my-2">
									<div className="w-full">
										<label
											className="block  text-xs font-bold"
											htmlFor="grid-password">
											Project
										</label>
										<div className="border-0  bg-[#F3F4F6FF] text-xs " >
											<input
												type="text"
												name={"project"}
												className="w-full px-3 py-1 bg-[#F3F4F6FF] text-xs"
												disabled={true}
												value={isEditTheme ? 'project' : ''}
											/>
										</div>
									</div>
								</div>
								<div className="flex flex-row space-x-2 px-4 w-full my-4">
									<div className="relative w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password" >
											Select Block
										</label>
										<div className="border-0  bg-[#F3F4F6FF] text-xs " >
											<div className="border-0  bg-black bg-opacity-10 text-xs " >
												<select
													className="w-full px-3 py-1 bg-[#F3F4F6FF] text-xs"
													onChange={(e) => handleSteps(e, 'Block')}
													value={'Block'}
												>
													<option value="1" key={1}>--Select--</option>

												</select>
											</div>
										</div>
									</div>
									<div className="w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password">
											Select Number Of Bedrooms
										</label>
										<div className="px-3 border-0  bg-[#F3F4F6FF] text-xs " >
											<select
												className="w-full py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'NumberOfBedrooms')}
												value={'NumberOfBedrooms'}
											>
												<option value="1" key={1}>--Select--</option>

											</select>
										</div>
									</div>
								</div>
								<div className="flex flex-row space-x-2 px-4 w-full my-4">
									<div className="relative w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password" >
											Select Project Type
										</label>
										<div className="border-0  bg-[#F3F4F6FF] text-xs " >
											<div className="border-0  bg-black bg-opacity-10 text-xs " >
												<select
													className="w-full px-3 py-1 bg-[#F3F4F6FF] text-xs"
													onChange={(e) => handleSteps(e, 'ProjectType')}
													value={'ProjectType'}
												>
													<option value="1" key={1}>--Select--</option>

												</select>
											</div>
										</div>
									</div>
									<div className="w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password">
											Select Type Of House
										</label>
										<div className="px-3 border-0  bg-[#F3F4F6FF] text-xs " >
											<select
												className="w-full py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'TypeOfHouse')}
												value={'TypeOfHouse'}
											>
												<option value="1" key={1}>--Select--</option>

											</select>
										</div>
									</div>
								</div>
								<div className="flex flex-row space-x-2 px-4 w-full my-2">
									<div className="w-full">
										<label
											className="block  text-xs font-bold"
											htmlFor="grid-password">
											Enter Unit Details
										</label>
										<div className="border-0  bg-[#F3F4F6FF] text-xs " >
											<input
												type="text"
												name={"UnitDetails"}
												className="w-full px-3 py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'UnitDetails')}
												value={'UnitDetails'}
											/>
										</div>
									</div>
								</div>
								<div className="my-4 border-b border-black border-opacity-20"></div>
								<div className="flex flex-row space-x-2 px-4 w-full my-2">
									<div className="w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password" >
											CRM Executive
										</label>
										<div className="px-3 border-0  bg-[#F3F4F6FF] text-xs " >
											<select
												className="w-full py-1 bg-[#F3F4F6FF] text-xs"
												onChange={(e) => handleSteps(e, 'AssignCRM')}
												value={'AssignCRM'}
											>
												<option value="1" key={1}>--Select--</option>

											</select>
										</div>
									</div>
									<div className=" w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password" >
											Site Engineer
										</label>
										<div className="px-3 border-0  bg-[#F3F4F6FF] text-xs " >
											<select
												className="w-full py-1 bg-black bg-opacity-0 text-xs"
												onChange={(e) => handleSteps(e, 'AssignSiteEngineer')}
												value={'AssignSiteEngineer'}
											>
												<option value="1" key={1}>--Select--</option>

											</select>
										</div>
									</div>
								</div> */}
								{/* <div className="flex flex-row space-x-2 px-4 w-full my-2">
									<div className=" w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password" >
											Stage
										</label>
										<div className="px-3 border-0  bg-[#F3F4F6FF] text-xs " >
											<select
												className="w-full py-1 bg-black bg-opacity-0 text-xs"
												onChange={(e) => handleSteps(e, 'Stage')}
												value={'Stage'}
											>
												<option value="1" key={1}>--Select--</option>

											</select>
										</div>
									</div>
									<div className="w-1/2">
										<label
											className="block text-xs font-bold mb-2"
											htmlFor="grid-password" >
											Status
										</label>
										<div className="px-3 border-0  bg-[#F3F4F6FF] text-xs " >
											<select
												className="w-full py-1 bg-black bg-opacity-0 text-xs"
												onChange={(e) => handleSteps(e, 'Status')}
												value={'Status'}
											>
												<option value="1" key={1}>--Select--</option>

											</select>
										</div>
									</div>
								</div> */}
								<div className="flex items-center justify-end space-x-3 px-6 py-4 mx-3 ">
									<button
										className="text-black rounded text-opacity-40 bg-transparent font-bold  px-2 text-xs  py-1"
										type="button"
										onClick={() => handleReset()}
									>
										Reset
									</button>
									<button
										className="bg-blue-500 rounded text-white font-bold px-2 text-xs py-1"
										type="button"
										onClick={() => handleSave()}
									>
										{isEditTheme ? 'Update' : 'Add'}
									</button>
								</div>
							</div>
						</div>
					</div>
					<div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
				</>
			) : null
			}
		</>
	);
}